<template>
  <div class="lodging-skeleton">
    <div class="skeleton-image"></div>
    <div class="skeleton-content">
      <div class="skeleton-header">
        <div class="skeleton-title"></div>
        <div class="skeleton-rating"></div>
      </div>
      <div class="skeleton-location"></div>
      <div class="skeleton-description"></div>
      <div class="skeleton-price"></div>
      <div class="skeleton-button"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LodgingSkeleton'
}
</script>

<style lang="scss" scoped>
.lodging-skeleton {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
  width: 100%;
  max-width: 1200px;
  gap: 0;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin-bottom: 20px;
  animation: pulse 1.5s ease-in-out infinite alternate;
}

.skeleton-image {
  width: 100%;
  height: 319px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
}

.skeleton-content {
  width: 100%;
  padding: 1.5rem;
  border-top: 1px solid #f0f0f0;
}

.skeleton-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  margin-top: 0.5rem;
}

.skeleton-title {
  width: 60%;
  height: 24px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
}

.skeleton-rating {
  width: 80px;
  height: 20px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
}

.skeleton-location {
  width: 40%;
  height: 16px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
  margin-bottom: 15px;
}

.skeleton-description {
  width: 100%;
  height: 16px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
  margin-bottom: 10px;
}

.skeleton-price {
  width: 30%;
  height: 20px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
  margin-bottom: 15px;
}

.skeleton-button {
  width: 135px;
  height: 49px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0.8;
  }
}

// Tablet and larger screens - vertical layout (same as mobile)
@media only screen and (min-width: 768px) {
  .lodging-skeleton {
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
    gap: 0;
    max-width: 1200px;
  }
  
  .skeleton-image {
    height: 400px;
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
    border-bottom-left-radius: 0;
  }
  
  .skeleton-content {
    padding: 2rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    border-top: 1px solid #f0f0f0;
    border-left: none;
  }
}

// Large desktop screens
@media only screen and (min-width: 1024px) {
  .lodging-skeleton {
    gap: 0;
  }
  
  .skeleton-image {
    height: 309px;
  }
  
  .skeleton-content {
    padding: 1rem;
  }
}

// Mobile devices
@media only screen and (max-width: 767px) {
  .lodging-skeleton {
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
    width: 100%;
    gap: 0;
    margin: 0 0 20px 0;
  }
  
  .skeleton-image {
    width: 100%;
    height: 250px;
    border-radius: 0;
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
  }
  
  .skeleton-content {
    width: 100%;
    padding: 1rem;
    border-top: 1px solid #f0f0f0;
    border-left: none;
  }
  
  .skeleton-header {
    margin-top: 0;
  }
  
  .skeleton-button {
    width: 100%;
    min-width: 135px;
  }
}

// Extra small mobile devices
@media only screen and (max-width: 480px) {
  .skeleton-image {
    height: 250px;
  }
  
  .skeleton-content {
    padding: 1rem;
  }
  
  .skeleton-button {
    height: 45px;
  }
}
</style>